<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-12">
    <h2>{{ $t("navigations.trial master file") }}</h2> 
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-body" v-if="showSelectTemplate==true">
      <div class="ibox-content">
        <div class="form-group mb-0">
          <label for="templateSelect">{{ $t('navigations.select a template') }}</label>
          <div class="d-flex flex-wrap">         
            <select v-model="selectedTemplate" class="form-select w-auto mr-2" name="template selection" id="templateSelect">
              <option value="">None</option>
              <option :value="template.id" v-for="template in templateList" :key="template.id">
                {{ template.templateName }}
              </option>
            </select>       
            <button type="button" @click="generateTree()" class="save_btn mt-2 mt-md-auto py-1 px-3 position-relative" :disabled="loadingGenerateBtn == true"
              :class="{ 'disabled-btn-cls': loadingGenerateBtn == true }">
              <div class="toc-loader position-absolute"
              :class="{ 'opacity-0': loadingGenerateBtn == false, 'opacity-1': loadingGenerateBtn == true }">
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
              </div>
              <p class="mb-0" :class="{ 'opacity-1': loadingGenerateBtn == false, 'opacity-0': loadingGenerateBtn == true }">{{
              $t("navigations.generate") }}</p>
            </button>
          </div>
        </div>
      </div>       
    </div>
    <div class="row">
      <div class="col-12 col-md-6 mb-1 mr-0 pr-0">
        <div class="ibox-body">
          <div class="ibox-title style_2 d-flex justify-content-between">
            <h5>{{ $t("navigations.folder list") }}</h5>
            <div class="position-relative">
              <img
                class="cursor-pointer mb-0"
                src="../../assets/img/dms_add_folder.png"
                alt="create folder"
                @click="createFolderfunc('addRoot')"
              />
              <div class="tool-tip">{{ $t("navigations.add folder") }}</div>
            </div>
          </div>
          <div class="ibox-content overflow-y-block">
            <div v-if="showTreeLoading==true" class="text-center"><img src="" alt="">
              <div>{{ $t("navigations.please wait while the tree is being generated") }}</div>
              <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
            </div>
            <div v-else id="primary-tmf-tree">
              <ul v-if="folderlist.length!=0" v-on:clickout="clickedOut($event)">                
                <TreeWithSidePopup
                  v-if="folderlist.length != 0"
                  :list="folderlist"        
                  :openfolderlist="openfolderlist"  
                  :countsMap="countsMap"      
                  @reloadFolders="getTree()"
                  @editFolder="editFolder()"
                  @addFolder="createFolderfunc('addSubFolder',$event)"
                  @deleteFolder="deleteFolder($event)"
                  @archiveFolder="archiveFolder()"
                  @cloneFolder="openCloneFolder($event)"
                  @exportFolder="exportFolder($event)"
                  @addFolderPermission="addFolderPermission($event)"
                  @shareFolderPermission="shareFolderPermission()"
                  @uploadDocument="openDocumentModal()"
                  @emptyChild="returnChild($event)"
                  @exportFolderTreeStructure="exportTreeFolderStructure($event)"
                  @folderType="returnFolderType($event)"
                  patid=""
                  :boldfolder ="`${bold}`"
                >
                </TreeWithSidePopup>
              </ul>
              <div class="text-center p-5" v-else>
                <img width="70" src="../../assets/img/EmptyFolder.svg" alt="No folder available">
                <h4 class="my-3">{{ $t('navigations.no folders found for this study') }}</h4>    
                <button type="button" @click="createFolderfunc('addRoot')" 
                class="save_btn py-1 px-3 position-relative"><p class="mb-0">
                   {{ $t("navigations.add folder") }}</p></button>             
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="ibody" >
          <div class="ibox-title style_2 d-flex justify-content-between px-3">
            <h5>{{ $t('navigations.documents') }}</h5>
            <button v-if="$store.getters.getFolderId" class="position-relative border-0 align-self-center p-0" @click.prevent="openDocumentModal()">
              <img class="cursor-pointer" src="../../assets/img/create.png" alt="Add a file" width="20" height="20"
                 />
              <span class="tool-tip">{{ $t('navigations.add documents') }}</span>
            </button>
          </div>
           <div class="ibox-content scrollable-block" id="primaryDocumentTree">
            <div class="text-center" v-if="showTableLoading">
              <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
              <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
            </div>
            <div v-else class="table-responsive">
              <table v-if="documentList.length!=0" class="table table-bordered">
                <thead>
                  <tr>
                    <th
                    > Document File Name</th>
                    <th> Document Title</th>
                    <th> Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(document, index) in documentList" :key="document.id">
                    <td class="align-items-center fixed-width-table-cell">
                      <div class="cursor-pointer" @click.prevent="viewDocument(document.id,document.name,document.latestVersion)" v-if="document && document.name && document.name.length < 41"> {{  document.name }}</div>
                      <div v-else>
                        <div v-if="!readMore[index]" class="breakWord">
                          <span class="cursor-pointer" @click.prevent="viewDocument(document.id,document.name,document.latestVersion)">{{
                            document.name ? document.name.substring(0, 40):'' }}</span>
                          <span @click="showMore(index)" v-if="!readMore[index]" class="cursor-pointer more-block">...More</span>
                        </div>
                        <div v-if="readMore[index]" class="breakWord">
                          <span class="cursor-pointer" @click.prevent="viewDocument(document.id,document.name,document.latestVersion)">{{ document.name }} </span>
                          <span @click="showLess(index)" v-if="readMore[index]" class="cursor-pointer less-block">...Less</span>
                        </div>
                      </div>
                    </td>
                    <td class="align-items-center fixed-width-table-cell">
                      <div class="cursor-pointer" @click.prevent="viewDocument(document.id,document.name,document.latestVersion)" v-if="document && document.documentTitle && document.documentTitle.length < 20" > {{ document.documentTitle }} </div>
                      <div v-else>
                        <div v-if="!readTitleMore[index]" class="breakWord">
                          <span class="cursor-pointer" @click.prevent="viewDocument(document.id,document.name,document.latestVersion)"> {{
                            document.documentTitle ? document.documentTitle.substring(0, 20) : ''}}</span>
                          <span class="cursor-pointer more-block" @click="showTitleMore(index)" v-if="!readTitleMore[index] && document.documentTitle" >...More</span>
                        </div>
                        <div v-if="readTitleMore[index]" class="breakWord">
                          <span class="cursor-pointer" @click.prevent="viewDocument(document.id,document.name,document.latestVersion)"> {{
                            document.documentTitle
                          }} </span>
                          <span class="cursor-pointer less-block" @click="showTitleLess(index)" v-if="readTitleMore[index]" >Less</span>
                        </div>
                      </div>
                    </td>
                    <td class="text-center" width="40">
                      <button class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-3 py-0"
                        :popovertarget="`tmf-docs-`+ document.id"
                        :anchor="`tmf-docs-`+ document.id"
                        @click="openSidePopup(document.id)"
                      >
                          <i class="fa fa-ellipsis-v"></i>
                      </button> 
                      <div 
                        :id="`tmf-docs-`+ document.id" popover class="tmf-docs-popup-menu">
                        <div class="text-center p-2 w-100" v-if="showDocLoading[document.id]"><img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" /></div>

                        <template v-else>
                          <div v-if="anyuserpermissions==false" class="pointer-none px-2 py-3">
                            Nothing to show
                          </div>
                          <button v-if="archiveValue" class="popup-menu-block text-start" @click.prevent="archiveDocument(`tmf-docs-`+ document.id,document.id,document.name,document.latestVersion.versionId)">Archive</button>
                          <button v-if="editValue" class="popup-menu-block text-start" @click.prevent="editDocument(document.id,`tmf-docs-`+ document.id,document.latestVersion.versionId)">Edit</button>
                          <button v-if="downloadValue" class="popup-menu-block text-start" @click.prevent="downloadDocument(document.id,`tmf-docs-`+ document.id,document.name)">Download</button>  
                          <button v-if="deleteValue" class="popup-menu-block text-start" @click.prevent="deleteDocument( document.id,`tmf-docs-`+ document.id)">Delete</button> 
                          <button v-if="permissionsValue" class="popup-menu-block text-start" @click.prevent="addFolderPermission('File',`tmf-docs-`+ document.id,document.id)">Permission</button>
                          <button v-if="shareValue" class="popup-menu-block text-start" @click.prevent="shareFolderPermission('File',`tmf-docs-`+ document.id,document.id)">Share</button> 
                          <button v-if="viewValue" class="popup-menu-block text-start" @click.prevent="viewDocument(document.id,document.name,`tmf-docs-`+ document.id,)">View</button>
 
                        </template>                            
                      </div>  
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center p-5" v-else>
                <img width="50" src="../../assets/img/EmptyFile.svg" alt="No file available">
                <h4 class="my-3" v-if="$store.getters.getFolderId==''">{{ $t('navigations.no documents found please choose a folder to list documents') }}</h4>  
                <h4 class="my-3" v-else>{{ $t('navigations.no documents found for this folder please add a document') }}</h4>        
                 <button v-if="$store.getters.getFolderId" type="button" @click="openDocumentModal()" 
                   class="save_btn py-1 px-3 position-relative"><p class="mb-0">
                   {{ $t("navigations.add documents") }}</p></button>                 
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <teleport to='#app'>
     <div class="blank-wrapper" v-if="initialPermissionLoader==true">
      <div class="text-center">
        <h2>{{`Please wait..`}}</h2>
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
    </div>
    <div class="blank-wrapper" v-if="initialLoader==true">
      <div class="text-center">
        <h2 v-if="initialLoader==true">{{`Please wait while the folder is being ${process}`}}</h2>
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
    </div>
    <div class="blank-wrapper" v-if="initialDocDownloader==true">
      <div class="text-center">
        <h2 >{{`Please wait while the document is being downloaded`}}</h2>
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
    </div>
     <div class="blank-wrapper" v-if="initialTreeDownloader==true">
      <div class="text-center">
        <h2 >{{`Please wait while the tree structure is being exported`}}</h2>
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
    </div>
  </teleport>
  <!-- Create folder modal starts -->
  <customModal v-if="showFolder==true" :containersm=true @closeModal="addFolderModalClose">
    <template #title>
      {{ $t("navigations.add folder") }}
    </template>
    <template #body>
          <label for="designation">Folder Name<sup><i class="fa fa-asterisk field-validation"></i></sup></label>
          <input placeholder="Enter folder name" type="text" class="form-control" v-model="folderbyid.name"
            maxlength="75" />
          <span class="errorClass" v-if="editFolderErrors[0] == true">{{ folderErrorMessages[0] }}
          </span>
         <div class="mt-2">
            <label for="folderType">Enter Type<sup><i class="fa fa-asterisk field-validation"></i></sup></label>
            <input             
              id="folderType"
              type="text"
              class="form-control" 
              :disabled="isEditable==false" 
              v-model="folderType"
              maxlength="75"
            />
            <span class="errorClass" v-if="editFolderErrors[1] == true"
              >Please enter a folder type
            </span> 
          </div>
          <!-- <div class="my-2">
            <label  for="format">Select Format </label>
            <Multiselect id="format" valueProp="label" v-model="SelectedFormat" mode="multiple"
              placeholder="Select Format" :options="FormatList" :hideSelected="false" :closeOnSelect="false"
              class="multiselect-custom-theme">
              <template v-slot:option="{ option }">
                {{ option.label }}
              </template>
            </Multiselect>
          </div> -->

          <!-- <label>Document version configuration</label>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label for="prefix"><small>Prefix</small></label>
                <input maxlength="1" id="prefix" name="prefix" type="text" class="form-control required"
                  v-model="prefix" aria-required="true" v-on:keypress="isLetter($event)" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="majorVersion"><small>* Major ver.</small></label>
                <input maxlength="2" id="majorVersion" name="major version" type="text" class="form-control required"
                  v-model="majorVerStart" aria-required="true" @keypress="isNumber($event)" autocomplete="off" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="minorVersion"><small>Minor ver.</small></label>
                <input maxlength="2" id="minorVersion" name="minor version" type="text" class="form-control required"
                  v-model="minorVerStart" aria-required="true" @keypress="isNumber($event)" autocomplete="off" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="minorMaxVersion"><small>Minor Max.</small></label>
                <input maxlength="2" id="minorMaxVersion" name="minor max" type="text" class="form-control required"
                  v-model="minorVermax" @keypress="isNumber($event)" autocomplete="off" aria-required="true" />
              </div>
            </div>
            <span class="errorClass" v-if="editFolderErrors[1] == true">Minor Max value must be greater than or equal to Minor
              version value
            </span>
          </div> -->

          <div class="form-group mb-0 mt-3 d-flex justify-content-center">
            <!-- <div class="d-flex">
              <strong> Document version :</strong>
              {{ prefix }} {{ majorVerStart
              }}<span v-if="majorVerStart && minorVerStart != ''">.</span>{{ minorVerStart }}
            </div>                 -->
            <button type="button" class="save_btn py-1 px-4 mr-2 position-relative"
              @click="addFolder()" :class="{ 'disabled-btn-cls': loadingEditFolder == true }">
              <div class="toc-loader position-absolute"
              :class="{ 'opacity-0': loadingEditFolder == false, 'opacity-1': loadingEditFolder == true }">
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
              </div>
              <p class="mb-0" :class="{ 'opacity-1': loadingEditFolder == false, 'opacity-0': loadingEditFolder == true }">{{
              $t("navigations.add") }}</p>
          </button>
        </div>
    </template>
  </customModal>
  <!-- Create folder modal ends -->
  <!-- Edit folder modal starts -->
  <customModal v-if="editFolderModal==true" :containersm=true @closeModal="editFolderModalClose">
    <template #title>
      {{ $t("navigations.edit folder") }}
    </template>
    <template #body>
         <label for="folderName">Enter Folder Name<sup><i class="fa fa-asterisk field-validation"></i></sup></label>
        <input
          type="text"
          id="folderName"
          class="form-control"
          v-model="folderbyid.name"
          maxlength="75"
        />
        <span class="errorClass" v-if="editFolderErrors[0] == true"
          >Please enter a folder name
        </span> 
       <div class="mt-2">
          <label for="folderType">Enter Type <sup><i class="fa fa-asterisk field-validation"></i></sup></label>
          <input
            id="folderType"
            type="text"
            class="form-control"
            v-model="folderType"
            maxlength="75"
          />
          <span class="errorClass" v-if="editFolderErrors[1] == true"
            >Please enter a folder type
          </span> 
        </div>        
        <div class="row mt-3">
          <!-- <div class="col-6"><strong> Document version :</strong>
            {{ prefix }} {{ majorVerStart }}<span v-if ="majorVerStart && minorVerStart !=''">.</span>{{
              minorVerStart
            }} 
            </div> -->
            <div class="col-12 text-center">
            <button type="button" class="save_btn py-1 px-3 position-relative" :disabled="loadingEditFolder == true"
                @click.prevent="updatefolder(folderbyid.name,folderType)" :class="{ 'disabled-btn-cls': loadingEditFolder == true }">
                <div class="toc-loader position-absolute"
                :class="{ 'opacity-0': loadingEditFolder == false, 'opacity-1': loadingEditFolder == true }">
                <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                </div>
                <p class="mb-0" :class="{ 'opacity-1': loadingEditFolder == false, 'opacity-0': loadingEditFolder == true }">{{
                $t("navigations.save") }}</p>
              </button>
            </div>
            
        </div>
    </template>
  </customModal>
  <!-- Edit folder modal ends -->
  <!-- Clone folder modal starts -->
  <customModal v-if="cloneFolderModal==true" :containersm=true @closeModal="cloneFolderModalClose">
    <template #title>
      {{ $t("navigations.clone folder") }}
    </template>
    <template #body>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mb-2">
            <label class="mb-0 mr-1" for="cloneType"
              >{{ $t('navigations.choose action to clone') }}</label
            >
            <span class="field-validation">*</span>
            <select id="cloneType" class="form-select" v-model="cloneType">
              <option selected value="">None</option>
              <option value="folderonly">Only Folder</option>
              <option value="folderpermission">
                Folders and permission
              </option>
              <option value="folderfilepermission">
                Folder,permission and files
              </option>
            </select>
            
          </div>
          <div class="col-12 mb-2">
            <label class="mb-0 mr-1" for="newFolderName"
              >{{ $t('navigations.folder name') }}</label
            >              
            <input class="form-control" id="newFolderName"
            v-model="newFolderName"
            >

          </div>
            <div class="overflow-y-modal">
              <label class="mb-0" for="folderLocation">{{ $t('navigations.choose target') }}</label>
              <ul v-if="folderlist.length!=0">                
                <TreeMove
                  v-if="folderlist.length != 0"
                  :list="folderlist"                
                  patid=""
                  :boldfolder ="`${bold}`"
                >
                </TreeMove>
              </ul>
            </div>
          </div>
      </div>
      <div class="modal-footer pb-0">
        <div
          class="d-flex justify-content-end"
        >
        <button type="button" class="save_btn py-1 px-3 position-relative" :disabled="loadingCloneFolder == true"
          @click.prevent="cloneFolder()" :class="{ 'disabled-btn-cls': loadingCloneFolder == true }">
          <div class="toc-loader position-absolute"
          :class="{ 'opacity-0': loadingCloneFolder == false, 'opacity-1': loadingCloneFolder == true }">
          <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
          </div>
          <p class="mb-0" :class="{ 'opacity-1': loadingCloneFolder == false, 'opacity-0': loadingCloneFolder == true }">{{
          $t("navigations.clone") }}</p>
        </button>
      </div>
      </div>
    </template>
  </customModal>
  <!-- Clone folder modal ends -->
  <!-- Upload Document modal starts -->
  <customModal v-if="uploadDocumentModal==true" :containermd=true @closeModal="uploadDocumentModalClose">
    <template #title>
     <span v-if="documentEdit==false">{{ $t("navigations.upload document") }}</span>
      <span v-else>{{ $t("navigations.edit document") }}</span>
    </template>
    <template #body>
      <div v-if="documentEdit==false">
          <div class="row">
        <div class="col-12 col-md-6 pr-md-1 mt-2">
          <label for="document title"
            >Document Title</label
          >
          <input
          placeholder="Enter document title"
            type="text"
            id="document-title"
            v-model="docTitle"
            class="form-control"
            maxlength="75"
          />
          
        </div>
        <div
          class="col-12 col-md-6 mt-2"
        >
          <label id="version">Version</label>
          <input
          placeholder="Enter version"
            type="text"
            for="version"
            v-model="this.docVersion"
            class="form-control"
            maxlength="10"
            :readonly="documentEdit==true"
          />
          
        </div>
           <div class="col-12 col-md-6 pr-md-1 mt-2">
              <label for="documentOwner">Select Owner</label>
              <select
                id="documentOwner"
                v-model="documentUploadFields.owner"
                class="mr-3 form-select form-select-lg"
              >
              <option value="" disabled>Select Owner</option>
                <option v-for="(users,index) in ownerList" :key="index" :value="`${users.firstName} ${users.lastName}`">
                  {{ `${users.firstName} ${users.lastName}`}}
                </option>
              </select>
              
            </div>
        <div
          class="col-12 col-md-6 mt-2"
        >
          <label id="expiry-date">Expiry Date</label>
          <input
          placeholder="Select a date "
            for="expiry-date"
            type="text"
            v-model="documentUploadFields.expiryDate"
            class="form-control"
            onfocus="(type='date')"
            onblur="(type='text')"
            maxlength="30"
          />
          <span class="d-block errorClass" v-if="documentValidationsError[3] == true">
            Please enter a future date
          </span>
        </div>
        <div
          class="col-12 col-md-6 mt-2"
        >
          <label id="expiry-date">Expected Completion Date</label>
          <input
          placeholder="Select a date "
            for="expiry-date"
            type="text"
            v-model="documentUploadFields.ExpectedCompletionDate"
            class="form-control"
            onfocus="(type='date')"
            onblur="(type='text')"
            maxlength="30"
          />
          <span class="d-block errorClass" v-if="documentValidationsError[1] == true">
            Please enter a future date
          </span>
        </div>
        <div class="col-12 mt-2">
          <label id="description">Description</label>
          <textarea
          placeholder="Enter description"
            id="description"
            class="form-control"
            v-model="documentUploadFields.description"
            maxlength="250"
          ></textarea>
        </div>
        <div class="col-12 mt-2">
          <label id="changesHistory">Changes History</label>
          <textarea
          placeholder="Enter changes history"
            id="changesHistory"
            class="form-control"
            v-model="documentUploadFields.changesHistory"
            maxlength="250"
          ></textarea>
        </div>
        <!-- <div
          v-if="documentUploadFields.documentType.trim() != ''"
          class="col-12 mt-2 form-check"
        >
          <input
            class="form-check-input"
            v-model="addsigner"
            type="checkbox"
            @change="createbookmarkuserarray()"
            value=""
            id="flexCheckDefault"
          />
          <label class="form-check-label ml-4" for="flexCheckDefault">
            Do you need to add signer ?
          </label>
        </div> -->
        <!-- <div class="col-12 mt-2" v-if="addsigner">
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Signing order
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Bookmark/Role
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    User
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(bookmarks, index) in bookmarklist"
                :key="bookmarks"
              >
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ bookmarklist[index].bookmarkName }}
                </td>
                <td>
                  <select
                    id="user"
                    class="mr-3 form-select form-select-lg"
                    aria-label=".form-select-lg example"
                    :disabled="
                      index != 0 &&
                      bokkmarkusersarray[index - 1].userID == ''
                    "
                    @change="assignbookmarkuserfun($event, index)"
                  >
                    <option value="" selected disabled>
                      --Select a User--
                    </option>
                    <option
                      v-for="users in signuserList"
                      :value="
                        users.id + ',' + users.email + ',' + users.name
                      "
                      :key="users.id"
                    >
                      {{ users.name }}
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <div class="col-12 mt-2">
          <input
            accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx,.doc"
            id="InPutFile"
            type="file"
            class="form-control d-none my-2 my-md-0"
            @change="previewFiles"
            multiple
          />
          <div
            class="input-group"
            v-for="(eachfiles, index) in list"
            :key="eachfiles"
          >
            <div class="listfile breakWord">
              <a>
                {{ eachfiles.name }}
                <i
                  class="fa fa-close"
                  @click.prevent="removefile(index)"
                ></i
              ></a>
            </div>
          </div>
          <span class="errorClass" v-if="documentValidationsError[2] == true">
            Please upload a file
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button class="browser-btn py-1 px-3 mr-2"
          type="button"
          @click="loadfile()"
        >
         <p class="mb-0">{{ $t('navigations.browse') }}</p> 
        </button>
         <button type="button" @click="submitFile()" class="save_btn py-1 px-3 position-relative" :disabled="loadingDocUpload == true"
          :class="{ 'disabled-btn-cls': loadingDocUpload == true }">
          <div class="toc-loader position-absolute"
          :class="{ 'opacity-0': loadingDocUpload == false, 'opacity-1': loadingDocUpload == true }">
          <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
          </div>
          <p class="mb-0" :class="{ 'opacity-1': loadingDocUpload == false, 'opacity-0': loadingDocUpload == true }">{{
          $t("navigations.save") }}</p>
        </button>
      </div>
      </div>
      <div v-else>
        <div class="text-center" v-if="documentLoader==true">
          <h4>{{`Please wait while the data is being fetched`}}</h4>
          <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
        </div>
        <div v-else>
          <div class="row">
        <div class="col-12 col-md-6 pr-md-1 mt-2">
          <label for="document title"
            >Document Title</label
          >
          <input
          placeholder="Enter document title"
            type="text"
            id="document-title"
            v-model="docTitle"
            class="form-control"
            maxlength="75"
          />
          
        </div>
        <div
          class="col-12 col-md-6 mt-2"
        >
          <label id="version">Version</label>
          <input
          placeholder="Enter version"
            type="text"
            for="version"
            v-model="this.docVersion"
            class="form-control"
            maxlength="10"
            :readonly="documentEdit==true"
          />
        </div>
           <div class="col-12 col-md-6 pr-md-1 mt-2">
              <label for="documentOwner">Select Owner</label>
              <select
                id="documentOwner"
                v-model="documentUploadFields.owner"
                class="mr-3 form-select form-select-lg"
              >
                <option v-for="(users,index) in ownerList" :key="index" :value="`${users.firstName} ${users.lastName}`">
                  {{ `${users.firstName} ${users.lastName}`}}
                </option>
              </select>
              
            </div>
        <div
          class="col-12 col-md-6 mt-2"
        >
          <label id="expiry-date">Expiry Date</label>
          <input
          placeholder="Select a date "
            for="expiry-date"
            type="text"
            v-model="documentUploadFields.expiryDate"
            class="form-control"
            onfocus="(type='date')"
            onblur="(type='text')"
            maxlength="30"
          />
          <span class="d-block errorClass" v-if="documentValidationsError[1] == true">
            Please enter a future date
          </span>
        </div>
        <div class="col-12 mt-2">
          <label id="description">Description</label>
          <textarea
          placeholder="Enter description"
            id="description"
            class="form-control"
            v-model="documentUploadFields.description"
            maxlength="250"
          ></textarea>
        </div>
        <div class="col-12 mt-2">
          <label id="changesHistory">Changes history</label>
          <textarea
          placeholder="Enter changes history"
            id="changesHistory"
            class="form-control"
            v-model="documentUploadFields.changesHistory"
            maxlength="250"
          ></textarea>
        </div>
        <!-- <div
          v-if="documentUploadFields.documentType.trim() != ''"
          class="col-12 mt-2 form-check"
        >
          <input
            class="form-check-input"
            v-model="addsigner"
            type="checkbox"
            @change="createbookmarkuserarray()"
            value=""
            id="flexCheckDefault"
          />
          <label class="form-check-label ml-4" for="flexCheckDefault">
            Do you need to add signer ?
          </label>
        </div> -->
        <!-- <div class="col-12 mt-2" v-if="addsigner">
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Signing order
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    Bookmark/Role
                  </div>
                </th>
                <th class="sort_block" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    User
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(bookmarks, index) in bookmarklist"
                :key="bookmarks"
              >
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ bookmarklist[index].bookmarkName }}
                </td>
                <td>
                  <select
                    id="user"
                    class="mr-3 form-select form-select-lg"
                    aria-label=".form-select-lg example"
                    :disabled="
                      index != 0 &&
                      bokkmarkusersarray[index - 1].userID == ''
                    "
                    @change="assignbookmarkuserfun($event, index)"
                  >
                    <option value="" selected disabled>
                      --Select a User--
                    </option>
                    <option
                      v-for="users in signuserList"
                      :value="
                        users.id + ',' + users.email + ',' + users.name
                      "
                      :key="users.id"
                    >
                      {{ users.name }}
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <div class="col-12 mt-2">
          <input
            accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx,.doc"
            id="InPutFile"
            type="file"
            class="form-control d-none my-2 my-md-0"
            @change="previewFiles"
            multiple
          />
          <div
            class="input-group"
            v-for="(eachfiles, index) in list"
            :key="eachfiles"
          >
            <div class="listfile breakWord">
              <a>
                {{ eachfiles.name }}
                <i
                  class="fa fa-close"
                  @click.prevent="removefile(index)"
                ></i
              ></a>
            </div>
          </div>
          <span class="errorClass" v-if="documentValidationsError[2] == true">
            Please upload a file
          </span>
        </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <button class="browser-btn py-1 px-3 mr-2"
              type="button"
              @click="loadfile()"
            >
            <p class="mb-0">{{ $t('navigations.browse') }}</p> 
            </button>
            <button type="button" @click="submitFile()" class="save_btn py-1 px-3 position-relative" :disabled="loadingDocUpload == true"
              :class="{ 'disabled-btn-cls': loadingDocUpload == true }">
              <div class="toc-loader position-absolute"
              :class="{ 'opacity-0': loadingDocUpload == false, 'opacity-1': loadingDocUpload == true }">
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
              </div>
              <p class="mb-0" :class="{ 'opacity-1': loadingDocUpload == false, 'opacity-0': loadingDocUpload == true }">{{
              $t("navigations.save") }}</p>
            </button>
          </div>
        </div>        
      </div>     
    </template>
  </customModal>
  <!-- Upload Document modal ends -->
  <!-- Folder tree permission modal starts -->
  <customModal v-if="openPermissionModal==true" :containermd=true :footerShow=true @closeModal="permissionModalClose">
    <template #title>
      {{ $t("navigations.folder permission") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
            <label for="chooseFolderRole">Designations</label>
            <Multiselect
              name="designation"
              id="chooseFolderRole"
              valueProp="id"
              mode="multiple"
              placeholder="Select"
              :options="roleList"
              :hideSelected="false"
              :closeOnSelect="false"
              class="multiselect-theme"
              size="30"
              @change="onChange($event,'folder')"
              v-model="designation"
            > <template v-slot:option="{ option }">
                {{ option.role_Name }}
              </template>
            </Multiselect>
        </div>
      </div>  
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  id="selectall"
                  @change="selectall()"
                />
                Name
              </th>
              <th
                v-for="permissions in permissionList"
                :key="permissions.id"
              >
                <input
                  type="checkbox"
                  :id="permissions.permission"
                  @change="setpermissions(permissions.permission)"
                />
                {{ permissions.permission }}
              </th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="options in userList" :key="options.id">
              <td>
                <input v-if="userobject[options.userID]"
                  type="checkbox"
                  :value="options.name"
                  :id="options.userID"
                  :checked="
                      userobject[options.userID] &&
                      Array.isArray(userobject[options.userID].permission) &&
                      userobject[options.userID].permission.length > 0
                  "
                  @change="setcontrols(options)"
                />
                {{ options.name }}
              </td>
              <td v-for="option in permissionList" :key="option.id">
                <input  v-if="userobject[options.userID]"
                  type="checkbox"
                  :value="option.permission"
                  :class="options.id"
                  v-model="userobject[options.userID].permission"
                  @change="selectuserwithpermission(options.userID)"
                />
                {{ option.permission }}
              </td>
              <td class="text-center">
                <button  @click="saveSinglePermission('folder',options.userID)" class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative" type="button" :disabled="loadingPermission[options.userID] == true"
                  :class="{ 'disabled-btn-cls': loadingPermission[options.userID] == true }">
                  <div class="toc-loader position-absolute"
                  :class="{ 'opacity-0': loadingPermission[options.userID] == false, 'opacity-1': loadingPermission[options.userID] == true }">
                  <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                  </div>
                  <p class="mb-0" :class="{ 'opacity-1': loadingPermission[options.userID] == false, 'opacity-0': loadingPermission[options.userID] == true }">{{
                  $t("navigations.save") }}</p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-between" v-if="selectedRole.length!=0 && userList.length!=0">
        <p class="my-0"> *Unsaved changes will be lost if switching designations.</p>
        <button type="button" @click="multiSavePermission('folder')" class="save_btn py-1 px-3 position-relative" :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }">
          <div class="toc-loader position-absolute"
          :class="{ 'opacity-0': loadingSaveModalBtn == false, 'opacity-1': loadingSaveModalBtn == true }">
          <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
          </div>
          <p class="mb-0" :class="{ 'opacity-1': loadingSaveModalBtn == false, 'opacity-0': loadingSaveModalBtn == true }">{{
          $t("navigations.save") }}</p>
        </button>
      </div>
    </template>
  </customModal>
  <!-- Folder tree permission modal ends -->
  <!-- Document permission modal starts -->
  <customModal v-if="openDocsPermissionModal==true" :containermd=true :footerShow="true" @closeModal="permissionModalClose('File')">
    <template #title>
      {{ $t("navigations.document permission") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
           <label class="">Designations</label>
        <Multiselect
          name="designation"
          valueProp="id"
          mode="multiple"
          placeholder="Select"
          :options="roleList"
          :hideSelected="false"
          :closeOnSelect="false"
          class="multiselect-theme"
          size="30"
          @change="onChange($event,'file')"
          v-model="designation"
        >
          <template v-slot:option="{ option }">
            {{ option.role_Name }}
          </template>
        </Multiselect>
        </div>
      </div>
      <h4>Users</h4>
        <div class="height-scroll">
          <table class="table fixed-header">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    id="selectall"
                    @change="selectall()"
                  />
                  Name
                </th>
                <th
                  v-for="permissions in permissionList"
                  :key="permissions.id"
                >
                  <input
                    type="checkbox"
                    :id="permissions.permission"
                    @change="setpermissions(permissions.permission)"
                  />
                  {{ permissions.permission }}
                </th>
                <th class="text-center">Save</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="options in userList" :key="options.id">
                <td>
                  <input v-if="userobject[options.userID]"
                    type="checkbox"
                    :value="options.name"
                    :id="options.userID"
                    :checked="
                         userobject[options.userID] &&
                        Array.isArray(userobject[options.userID].permission) &&
                        userobject[options.userID].permission.length > 0
                    "
                    @change="setcontrols(options)"
                  />
                  {{ options.name }}
                </td>
                <td v-for="option in permissionList" :key="option.id">
                  <input
                   v-if="userobject[options.userID]"
                    type="checkbox"
                    :value="option.permission"
                    :class="options.id"
                    v-model="userobject[options.userID].permission"
                    @change="selectuserwithpermission(options.userID)"
                  />
                  {{ option.permission }}
                </td>
                <td class="text-center">
                   <button class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative" type="button" @click="saveSinglePermission('file',options.userID)" :disabled="loadingPermission[options.userID] == true"
                  :class="{ 'disabled-btn-cls': loadingPermission[options.userID] == true }">
                  <div class="toc-loader position-absolute"
                  :class="{ 'opacity-0': loadingPermission[options.userID] == false, 'opacity-1': loadingPermission[options.userID] == true }">
                  <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                  </div>
                  <p class="mb-0" :class="{ 'opacity-1': loadingPermission[options.userID] == false, 'opacity-0': loadingPermission[options.userID] == true }">{{
                  $t("navigations.save") }}</p>
                </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-between" v-if="selectedRole.length!=0  && userList.length!=0">
        <p class="my-0"> *Unsaved changes will be lost if switching designations.</p>
        <button type="button" @click="multiSavePermission('file')" class="save_btn py-1 px-3 position-relative" :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }">
          <div class="toc-loader position-absolute"
          :class="{ 'opacity-0': loadingSaveModalBtn == false, 'opacity-1': loadingSaveModalBtn == true }">
          <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
          </div>
          <p class="mb-0" :class="{ 'opacity-1': loadingSaveModalBtn == false, 'opacity-0': loadingSaveModalBtn == true }">{{
          $t("navigations.save") }}</p>
        </button>
      </div>
    </template>
  </customModal>
  <!-- Document permission modal ends -->
  <!-- Folder share modal starts -->
  <customModal v-if="openFolderShareModal==true" :containermd=true :footerShow="true" @closeModal="closeShareFolderPermission()">
    <template #title>
    {{ $t("navigations.folder share") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
           <label class="">Choose Role</label>
         <select         
          class="form-select"
          name="account"
          @change="onChange($event)"
        >
          <option value="" disabled selected>-Select-</option>
          <option v-for="role in roleList" :key="role.id" :value="role.id">
            <span>
              {{ role.role_Name }}
            </span>
          </option>
        </select>
        </div>
      </div>
      <h4>Users</h4>
        <div class="height-scroll">
          <table class="table fixed-header">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    id="selectall"
                    @change="selectall()"
                  />
                  Name
                </th>
                <th
                  v-for="permissions in permissionList"
                  :key="permissions.id"
                >
                  <input
                    type="checkbox"
                    :id="permissions.permission"
                    @change="setpermissions(permissions.permission)"
                  />
                  {{ permissions.permission }}
                </th>
                <th class="text-center">Save</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="options in userList" :key="options.id">
                <td>
                  <input
                    type="checkbox"
                    :value="options.name"
                    :id="options.userID"
                    :checked="
                      userobject[options.userID].permission.length != 0
                    "
                    @change="setcontrols(options)"
                  />
                  {{ options.name }}
                </td>
                <td v-for="option in permissionList" :key="option.id">
                  <input
                    type="checkbox"
                    :value="option.permission"
                    :class="options.id"
                    v-model="userobject[options.userID].permission"
                    @change="selectuserwithpermission(options.userID)"
                  />
                  {{ option.permission }}
                </td>
                <td class="text-center">
                  <button  @click="saveSinglePermission('folder',options.userID)" class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative" type="button"  :disabled="loadingPermission[options.userID] == true"
                  :class="{ 'disabled-btn-cls': loadingPermission[options.userID] == true }">
                  <div class="toc-loader position-absolute"
                  :class="{ 'opacity-0': loadingPermission[options.userID] == false, 'opacity-1': loadingPermission[options.userID] == true }">
                  <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                  </div>
                  <p class="mb-0" :class="{ 'opacity-1': loadingPermission[options.userID] == false, 'opacity-0': loadingPermission[options.userID] == true }">{{
                  $t("navigations.save") }}</p>
                </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </template>
    <template #footer>
       <div class="d-flex justify-content-between" v-if="selectedRole.length!=0 && userList.length!=0">
        <p class="my-0"> *Unsaved changes will be lost if switching designations.</p>
        <button type="button" @click="multiSaveShare('Folder')" class="save_btn py-1 px-3 position-relative" :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }">
          <div class="toc-loader position-absolute"
          :class="{ 'opacity-0': loadingSaveModalBtn == false, 'opacity-1': loadingSaveModalBtn == true }">
          <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
          </div>
          <p class="mb-0" :class="{ 'opacity-1': loadingSaveModalBtn == false, 'opacity-0': loadingSaveModalBtn == true }">{{
          $t("navigations.share") }}</p>
        </button>
      </div>
    </template>
  </customModal>
  <!-- Folder share modal ends -->
  <!-- File share modal starts -->
  <customModal v-if="openFileShareModal==true" :containermd=true :footerShow="true" @closeModal="closeShareFolderPermission('File')">
    <template #title>
    {{ $t("navigations.document share") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
           <label class="">Choose Role</label>
         <select         
          class="form-select"
          name="account"
          @change="onChange($event,documentIdd)"
        >
          <option value="" disabled selected>-Select-</option>
          <option v-for="role in roleList" :key="role.id" :value="role.id">
            <span>
              {{ role.role_Name }}
            </span>
          </option>
        </select>
        </div>
      </div>
      <h4>Users</h4>
        <div class="height-scroll">
          <table class="table fixed-header">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    id="selectall"
                    @change="selectall()"
                  />
                  Name
                </th>
                <th
                  v-for="permissions in permissionList"
                  :key="permissions.id"
                >
                  <input
                    type="checkbox"
                    :id="permissions.permission"
                    @change="setpermissions(permissions.permission)"
                  />
                  {{ permissions.permission }}
                </th>
                <th class="text-center">Save</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="options in userList" :key="options.id">
                <td>
                  <input
                    type="checkbox"
                    :value="options.name"
                    :id="options.userID"
                    :checked="
                      userobject[options.userID].permission.length != 0
                    "
                    @change="setcontrols(options)"
                  />
                  {{ options.name }}
                </td>
                <td v-for="option in permissionList" :key="option.id">
                  <input
                    type="checkbox"
                    :value="option.permission"
                    :class="options.id"
                    v-model="userobject[options.userID].permission"
                    @change="selectuserwithpermission(options.userID)"
                  />
                  {{ option.permission }}
                </td>
                <td class="text-center">
                  <button  @click="saveSinglePermission('file',options.userID)" class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative" type="button"  :disabled="loadingPermission[options.userID] == true"
                  :class="{ 'disabled-btn-cls': loadingPermission[options.userID] == true }">
                  <div class="toc-loader position-absolute"
                  :class="{ 'opacity-0': loadingPermission[options.userID] == false, 'opacity-1': loadingPermission[options.userID] == true }">
                  <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                  </div>
                  <p class="mb-0" :class="{ 'opacity-1': loadingPermission[options.userID] == false, 'opacity-0': loadingPermission[options.userID] == true }">{{
                  $t("navigations.save") }}</p>
                </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </template>
    <template #footer>
       <div class="d-flex justify-content-between" v-if="selectedRole.length!=0 && userList.length!=0">
        <p class="my-0"> *Unsaved changes will be lost if switching designations.</p>
        <button type="button" @click="multiSaveShare('File')" class="save_btn py-1 px-3 position-relative" :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }">
          <div class="toc-loader position-absolute"
          :class="{ 'opacity-0': loadingSaveModalBtn == false, 'opacity-1': loadingSaveModalBtn == true }">
          <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
          </div>
          <p class="mb-0" :class="{ 'opacity-1': loadingSaveModalBtn == false, 'opacity-0': loadingSaveModalBtn == true }">{{
          $t("navigations.share") }}</p>
        </button>
      </div>
    </template>
  </customModal>
  <!-- File share modal ends -->
  <!-- File view modal starts -->
  <customModal v-if="openFileViewModal==true" :dynamicbodyxl="true" :containerxl=true  @closeModal="closeViewDocumentModal()">
    <template #title>
    {{ $t("navigations.document view") }}
    </template>
    <template #body>
      <h4>{{ documentName }}</h4>
        <div v-if="format == 'JPG' || format == 'JPEG'" >
          <img :src="source" alt="Italian Trulli" class="imgwidth">
        </div>
        <div v-if="format == 'pdf'" class="pdfembeded">
          <vue-pdf-embed :source="source" />
        </div>
        <div v-if="office.includes(format)" class="outsideframe">
          <iframe
            :src="officeurl"
            width="100%"
            height="650px"
            frameborder="0"
          ></iframe>
        </div>  
    </template>
  </customModal>
  <!-- File view modal ends -->
  </template>
<script src="./trialMasterFile.js"></script>
<style scoped>
.blank-wrapper{
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  color:rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
  pointer-events: auto;
}
.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
.overflow-y-block {
  overflow-y: auto;
  max-height: calc(100dvh - 200px)
}
.overflow-y-modal {
  overflow-y: auto;
  max-height: 300px
}

.more-block,
.less-block {
  font-size: 11px;
  color: #618bd7;
}

.fixed-width-table-cell{
  max-width: 65ch;
  text-wrap: auto;
}
.browser-btn{
  border: 1px solid #e7eaec;
  background-color: #e7eaec;
  border-radius: 0.25rem;
}

.height-scroll
{
  height: 250px;
  overflow-y: auto;
}
/* CSS Popover Styles */

.tmf-doc-ellipsis-btn{
    anchor-name:--manage-btn;
    border:0;
 }
  .tmf-docs-popup-menu {
    position:absolute;
    inset: auto;
    text-align: left;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
  }
  .tmf-docs-popup-menu{
    top:anchor(bottom);
    right:anchor(left);
    width:fit-content;
    margin-inline-end: 5px;
  }
  .tmf-docs-popup-menu{
    position-try-fallbacks: --bottom;
    top:anchor(bottom);
    right:anchor(right);
    width:160px;
  }
  .tmf-docs-popup-menu> button{
    width:100%;
    border:0;
    font-size:0.8rem;
    font-weight:400;
    color:rgba(0,0,0);
    padding: 0.6rem 0.8rem;
  }

  [popover]:popover-open {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    animation: fadeIn 0.2s ease-in-out;
  }

  .tmf-docs-popup-menu> .popup-menu-block:hover, .popup-submenu> div:hover{
    background-color: #e4eaf9;
  }

  @position-try --bottom{
    inset:auto;
    bottom:anchor(top);
    right:anchor(left)
  }
/* CSS Popover Styles */
.fixed-header th {
  top: 0px;
  position: -webkit-sticky;
  position: sticky;
  background-color: #fff;
}
.field-validation {
  font-size: 0.4rem;
  color: hsl(0, 100%, 50%);
}
.iframe-wrapper {
  width: 100%;
  height: 100vh;
}

.docusign-frame {
  width: 100%;
  height: 100%;
  border: none;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
 </style>